import { ReactComponent as Close } from './close.svg';

export default Close;
